export default "__VITE_ASSET__d41e72de__"